export { default } from "./Input-component";
